import './index.scss'
import './elements/all_elements'


import './form_grid.scss'
 
  // $('input[type="tel"]').mask("+38(099) 999-9999");
 
  